import { httpPurchaseOrder } from "../helper/http-common";
class PurchaseOrderServices {
  // <--- Purchase Order Details ---->

  GetMyPurchaseOrder(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetMyPurchaseOrder",
      inputData
    );
  }
  purchaseorderhistotry(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/purchaseorderhistotry",
      inputData
    );
  }
  UpdateOrderStatus(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/UpdateOrderStatus",
      inputData
    );
  }
  resendMail(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/resendMail",
      inputData
    );
  }
  sendEDI(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/sendEDI",
      inputData
    );
  }
  CreateReOrder(inputData) {
    return httpPurchaseOrder.post("/PurchaseOrder/CreateReOrder", inputData);
  }
  GetWorksheetDetails(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetWorksheetDetails",
      inputData
    );
  }
  UpdateWorkSheetStatus(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/UpdateWorkSheetStatus",
      inputData
    );
  }
  InsertWorksheetDetails(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/InsertWorksheetDetails",
      inputData
    );
  }
  RemoveWorkSheetName(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/RemoveWorkSheetName",
      inputData
    );
  }
  GetDashBoardMyPurchaseOrder(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetDashBoardMyPurchaseOrder",
      inputData
    );
  }
  GetDashBoardWorksheetDetails(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetDashBoardWorksheetDetails",
      inputData
    );
  }
  GetPOConnectedVendorDropdown(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetPOConnectedVendorDropdown",
      inputData
    );
  }
  GetWorksheetDetailsById(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetWorksheetDetailsById",
      inputData
    );
  }
  GetVendorListForSelectProduct(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetVendorListForSelectProduct",
      inputData
    );
  }
  UpdateWorkSheetDetailsById(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/UpdateWorkSheetDetailsById",
      inputData
    );
  }
  GetGetConfirmOrderDetailByID(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetGetConfirmOrderDetailByID",
      inputData
    );
  }
  GetWorksheetDetailsSelectedValue(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GetWorksheetDetailsSelectedValue",
      inputData
    );
  }
  UpdateWorkSheetName(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/UpdateWorkSheetName",
      inputData
    );
  }
  RemoveWorkSheetDetailsById(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/RemoveWorkSheetDetailsById",
      inputData
    );
  }
  GeneratePOForSelectedVendor(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GeneratePOForSelectedVendor",
      inputData
    );
  }
  CreateNewWorksheerdetils(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/CreateNewWorksheerdetils",
      inputData
    );
  }

  CreatePONumber(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/GenerateUniquePoNumber",
      inputData
    );
  }

  PlaceDiamondHold(inputData) {
    return httpPurchaseOrder.post("/PurchaseOrder/PlaceDiamondHold", inputData);
  }
  ReleaseDiamondHold(inputData) {
    return httpPurchaseOrder.post("/PurchaseOrder/ReleaseDiamondHold", inputData);
  }
  GetHoldStatusForStones(inputData) {
    return httpPurchaseOrder.post("/PurchaseOrder/GetHoldStatusForStones", inputData);
  }
  GetMyDiamondHolds(inputData) {
    return httpPurchaseOrder.post("/PurchaseOrder/GetMyDiamondHolds", inputData);
  }
  CreateFromBasket(inputData) {
    return httpPurchaseOrder.post("/DiamondDoc/CreateFromBasket", inputData);
  }
  ShipDiamondDoc(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondDoc/${id}/Ship`, inputData);
  }
  CancelUnsentDiamondDoc(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondDoc/${id}/CancelUnsent`, inputData);
  }
  ExtendDiamondDoc(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondDoc/${id}/Extend`, inputData);
  }
  AcceptDiamondDoc(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondDoc/${id}/Accept`, inputData);
  }
  PurchaseDiamondDoc(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondDoc/${id}/Purchase`, inputData);
  }
  ConfirmDiamondShipmentReceipt(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondShipment/${id}/ConfirmReceipt`, inputData);
  }
  ReturnDiamondDoc(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondDoc/${id}/Return`, inputData);
  }
  ReceiveDiamondShipment(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondShipment/${id}/Receive`, inputData);
  }
  GetInboundReturns(inputData) {
    return httpPurchaseOrder.post("/DiamondShipment/Inbound", inputData);
  }
  ReportDiamondDiscrepancy(lineId, inputData) {
    return httpPurchaseOrder.post(`/DiamondLine/${lineId}/Discrepancy`, inputData);
  }
  ResolveDiamondDiscrepancy(lineId, inputData) {
    return httpPurchaseOrder.post(`/DiamondLine/${lineId}/Resolve`, inputData);
  }
  GetDiamondTradeLockInfo(inputData) {
    return httpPurchaseOrder.post("/DiamondDoc/LockInfo", inputData);
  }
  GetSupplierDashboard(inputData) {
    return httpPurchaseOrder.post("/DiamondDashboard/Supplier", inputData);
  }
  GetDiamondActiveHolds(inputData) {
    return httpPurchaseOrder.post("/DiamondDashboard/ActiveHolds", inputData);
  }
  GetDiamondMemoAgeing(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/MemoAgeing", inputData);
  }
  ExportDiamondMemoAgeingCsv(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/MemoAgeing/CSV", inputData, { responseType: "arraybuffer" });
  }
  GetDiamondMemoConversion(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/MemoConversion", inputData);
  }
  ExportDiamondMemoConversionCsv(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/MemoConversion/CSV", inputData, { responseType: "arraybuffer" });
  }
  GetDiamondShippingCost(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/ShippingCost", inputData);
  }
  ExportDiamondShippingCostCsv(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/ShippingCost/CSV", inputData, { responseType: "arraybuffer" });
  }
  GetDiamondDiscrepancyReport(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/Discrepancies", inputData);
  }
  ExportDiamondDiscrepancyReportCsv(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/Discrepancies/CSV", inputData, { responseType: "arraybuffer" });
  }
  GetDiamondRetailerPurchases(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/RetailerPurchases", inputData);
  }
  ExportDiamondRetailerPurchasesCsv(inputData) {
    return httpPurchaseOrder.post("/DiamondReport/RetailerPurchases/CSV", inputData, { responseType: "arraybuffer" });
  }
  GetDiamondDoc(id, inputData) {
    return httpPurchaseOrder.post(`/DiamondDoc/${id}`, inputData);
  }
  GetDiamondDocList(inputData) {
    return httpPurchaseOrder.post("/DiamondDoc/List", inputData);
  }

  // <--- F2 (Feature 1860) / F3 (Feature 1861) - vendor-initiated orders ---->

  SetOrderTerms(inputData) {
    return httpPurchaseOrder.post("/PurchaseOrder/SetOrderTerms", inputData);
  }
  Transition(inputData) {
    return httpPurchaseOrder.post("/PurchaseOrder/Transition", inputData);
  }
  GetOrderHistory(poId) {
    return httpPurchaseOrder.get(`/PurchaseOrder/${poId}/History`);
  }
  CreateVendorWorksheet(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/CreateVendorWorksheet",
      inputData
    );
  }
  UpsertOrderLine(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/UpsertOrderLine",
      inputData
    );
  }
  RemoveOrderLine(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/RemoveOrderLine",
      inputData
    );
  }
  UpdateOrderLineQuantity(inputData) {
    return httpPurchaseOrder.post(
      "/PurchaseOrder/UpdateOrderLineQuantity",
      inputData
    );
  }
  GetMyOrdersByStatus(showId) {
    return httpPurchaseOrder.get("/PurchaseOrder/MyOrdersByStatus", {
      params: showId ? { showId } : {},
    });
  }
  GetOrderDetail(poId) {
    return httpPurchaseOrder.get(`/PurchaseOrder/${poId}/Detail`);
  }

  // <--- F4 (Feature 1862) - order contacts, non-registered recipients ---->

  SearchOrderContacts(inputData) {
    return httpPurchaseOrder.post("/OrderContact/Search", inputData);
  }
  UpsertOrderContact(inputData) {
    return httpPurchaseOrder.post("/OrderContact/Upsert", inputData);
  }
  CreateOrderRecipient(inputData) {
    return httpPurchaseOrder.post("/OrderRecipient/CreateNew", inputData);
  }

  // <--- F6 (Feature 1864) - show attribution ---->

  GetActiveShows() {
    return httpPurchaseOrder.get("/PurchaseOrder/ActiveShows");
  }

  // <--- F7 (Feature 1865) - vendor/retailer order reporting ---->

  GetOrderReport(inputData) {
    return httpPurchaseOrder.post("/Report/VendorOrders", inputData);
  }
  ExportOrderReportCsv(inputData) {
    return httpPurchaseOrder.post("/Report/VendorOrders/CSV", inputData, {
      responseType: "arraybuffer",
    });
  }
  ExportOrderReportPdf(inputData) {
    return httpPurchaseOrder.post("/Report/VendorOrders/PDF", inputData, {
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json", Accept: "application/pdf" },
    });
  }

  // <--- F8 (Feature 1866) - organizer dashboard ---->

  AssignShowOrganizer(inputData) {
    return httpPurchaseOrder.post("/Organizer/AssignShow", inputData);
  }
  RunAggregationNow(showId) {
    return httpPurchaseOrder.post("/Organizer/RunAggregationNow", null, {
      params: showId ? { showId } : {},
    });
  }
  GetMyShows() {
    return httpPurchaseOrder.get("/Organizer/MyShows");
  }
  GetDashboardHeadline(showId) {
    return httpPurchaseOrder.get(`/Organizer/Dashboard/${showId}/Headline`);
  }
  GetDashboardLeaderboards(showId) {
    return httpPurchaseOrder.get(`/Organizer/Dashboard/${showId}/Leaderboards`);
  }
  GetDashboardTiming(showId) {
    return httpPurchaseOrder.get(`/Organizer/Dashboard/${showId}/Timing`);
  }
  GetDashboardRelationships(showId) {
    return httpPurchaseOrder.get(`/Organizer/Dashboard/${showId}/Relationships`);
  }

  // Task 1908 (Feature 1863 / F5): first-ever frontend callers of this endpoint - the
  // backend has existed since F5, no screen ever wired to it until Epic 1857's UI-redesign
  // Phase 7.
  GetDeliverySettings(scope, ownerId) {
    return httpPurchaseOrder.get(`/DeliverySetting/${scope}/${ownerId}`);
  }
  UpsertDeliverySetting(inputData) {
    return httpPurchaseOrder.post("/DeliverySetting/Upsert", inputData);
  }
  DeactivateDeliverySetting(deliverySettingId) {
    return httpPurchaseOrder.post("/DeliverySetting/Deactivate", { deliverySettingId });
  }

  // Task 1904/1905 (Feature 1863 / F5): "Preview document" button (Epic 1857 UI-redesign
  // Phase 8) - GenerateDocument creates one on demand if none exists yet; GetOrderDocuments
  // lists what's already been generated/delivered for the order.
  GenerateOrderDocument(poId, documentType) {
    return httpPurchaseOrder.post("/PurchaseOrder/GenerateDocument", { poId, documentType });
  }
  GetOrderDocuments(poId) {
    return httpPurchaseOrder.get(`/PurchaseOrder/${poId}/Documents`);
  }

  // Epic 1857 UI-redesign Phase 9: replaces Dealer API's GetALLRetailerList for
  // OrderContactPicker.js - see PoContactService.SearchRetailersAsync for why (that proc
  // computed 11 unused correlated subqueries per row before pagination, and its "Status"
  // column was never really a connection indicator despite the picker checking it as one).
  SearchRetailers(search, pageIndex = 1, pageSize = 50) {
    return httpPurchaseOrder.post("/OrderContact/SearchRetailers", { search, pageIndex, pageSize });
  }
}
export default new PurchaseOrderServices();
